<template>
  <div class="progress">
    <div class="progress-determinate" :style="{ width: progressPercentage }" />
  </div>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export default {
  props: {
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    progressPercentage: function() {
      return `${this.progress * 100}%`
    },
  },
}
</script>
